export default {
  // 搜索选择器
  transactionDirection: "交易方向",
  virtualCurrency: "虚拟币币种",
  fiatCurrency: "法币币种",
  pleaseSelect: "请选择",
  totalAmount: "总数量",
  transactionAmount: "交易数量",
  minAmount: "最小金额",
  maxAmount: "最大金额",
  maxAmountWarning: "最大数量需≥最小数量",

  // 日期选择器
  dateRangeSeparator: "→",
  startDatePlaceholder: "开始日期",
  endDatePlaceholder: "结束日期",

  // 按钮
  reset: "重置",
  query: "查询",

  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列
  direction: "交易方向",
  currency: "币种",
  quantity: "交易数量",
  unitPrice: "单价",
  fiatCurrencyColumn: "法币",
  totalMoney: "总金额",
  transactionTime: "交易时间",

  // 交易方向
  buy: "买入",
  sell: "卖出",
  unknown: "未知",

  // 空状态
  noOtcData: "当前调证文件中未解析到OTC交易数据",

  // 下载
  downloadDetails: "下载数据明细",
  downloadFileName: "数据明细",
};
